// src/components/admin/ReviewButton.tsx

import React from 'react';
import { Eye } from 'lucide-react';

interface ReviewButtonProps {
    onClick: (e: React.MouseEvent) => void;
    label?: string;
    variant?: 'primary' | 'warning' | 'success' | 'danger';
    size?: 'sm' | 'md';
    className?: string;
}

const ReviewButton: React.FC<ReviewButtonProps> = ({
    onClick,
    label = 'Review',
    variant = 'primary',
    size = 'sm',
    className = '',
}) => {
    const variantStyles = {
        primary: 'text-blue-600 hover:text-blue-700 hover:bg-blue-50',
        warning: 'text-amber-600 hover:text-amber-700 hover:bg-amber-50',
        success: 'text-green-600 hover:text-green-700 hover:bg-green-50',
        danger: 'text-red-600 hover:text-red-700 hover:bg-red-50',
    };

    const sizeStyles = {
        sm: 'text-sm gap-1',
        md: 'text-base gap-2 px-3 py-1.5',
    };

    return (
        <button
            onClick={onClick}
            className={`font-medium flex items-center rounded-lg transition-colors p-1 ${variantStyles[variant]} ${sizeStyles[size]} ${className}`}
        >
            <Eye className={`${size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'}`} />
            {label}
        </button>
    );
};

export default ReviewButton;